/**
 * =============================================================================
 * DRAG TYPES - Shared constants for @dnd-kit drag-and-drop
 * =============================================================================
 * 
 * These constants identify the type of item being dragged:
 * - STEP: An existing workflow node being reordered
 * - TOOL: A sidebar tool being dragged to create a new step
 * 
 * Used in drag data to determine how to handle the drop operation.
 * =============================================================================
 */

export const DRAG_TYPES = {
    STEP: 'STEP',   // Existing workflow node (reordering)
    TOOL: 'TOOL',   // Sidebar item (adding new step)
};
